import * as React from 'react'
import { Button as UIButton } from '@/components/ui/button'

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	disabled?: boolean | false
	isWhite?: boolean | false
	extraClasses?: string
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
	({ children, disabled, isWhite, extraClasses, ...props }, ref) => {
		return (
			<UIButton
				ref={ref}
				variant={isWhite ? 'outline' : 'default'}
				disabled={disabled}
				className={`hover:shadow-lg hover:scale-105 active:scale-95 transition-all duration-300 ease-in-out ${isWhite ? 'border-purple-600 text-purple-600 bg-transparent hover:bg-purple-50 hover:text-purple-700' : ''} ${extraClasses}`}
				{...props}
			>
				{children}
			</UIButton>
		)
	}
)
Button.displayName = 'Button'

export { Button }
